import React from "react"
import Icon from "react-native-vector-icons/AntDesign"

export function BackIcon(props: { color: string, size: number }) {
	const { color, size } = props
	return <Icon name="back" color={color} size={size} />
}
